import ControlCenterPage from "./ControlCenterPage";
export default ControlCenterPage;
